module.exports = __webpack_public_path__ + "img/mstar_dbrs_logo.801fcfa7.png";